export const buildProvenance = { "commitHash": "f46a4b53194e572d87de2a396d601e3c44aad8af", "branchName": "refs/heads/release/2025.3", "buildDate": "2025-11-07T02:02:34.747Z", "version": "2025.3.14455" };
